/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import LoggedIn from './logged-in';

const LoggedInMe = (props) => {
    return <LoggedIn {...props} />;
}


export default LoggedInMe;
    